import { Schedule } from '@styled-icons/material';
import { Box } from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { PageTitle } from '~/components/Elements';
import QuestionForm from '~/components/QuestionForm';
import Time from '~/components/Time';
import WysiwygText from '~/components/WysiwygText';
import { access_control } from '~/containers/Auth/AccessControl';
import LiveFeed from '~/containers/LiveFeed';
import LiveFilter from '~/containers/RoundTip/LiveFeed/LiveFilter';
import emptyIcon from '~/images/empty-state.svg';
import { colors, spacing } from '~/utils/css-mixins';
import media from '~/utils/media';

import { InterviewItem } from '../Interviews';

const StyledPageTitle = styled(PageTitle)`
  position: relative;
`;

const Info = styled.p`
  margin-top: 8px;
  font-size: 14px;
  font-style: italic;
  line-height: 20px;
  color: ${colors.textmeta};
`;

const HeaderDiv = styled.div`
  margin-bottom: ${spacing.siteGutter * 2}px;
`;

const LiveItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const Timeline = styled.div`
  border-left: solid 2px ${colors.bluedark};
  margin-left: 10px;
  position: relative;
  top: -4px;
  flex: 1;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

const StyledSchedule = styled(Schedule)`
  width: 20px;
  height: 30px;
  margin-right: 5px;
  margin-left: -10px;
  padding: 5px 0;
  fill: ${colors.bluedark};
  position: relative;
  top: -2px;
  background-color: ${colors.white};
`;

const PostWrapper = styled.div`
  width: 100%;
  border-bottom: solid 1px ${colors.border};
  margin-bottom: 20px;
  margin-left: -30px;
  margin-top: 30px;
  padding-bottom: 20px;

  ${media.phone`
    margin-top: 0;
    margin-left: ${spacing.siteGutter * 2}px;
  `}
`;

const StyledWysiwygText = styled(WysiwygText)`
  font-size: 14px;
  line-height: 22px;
`;

const EmptyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 70px 0;
`;

const EmptyInformText = styled.p`
  color: #222;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin-top: 50px;
`;

const informTextMap = {
  all: 'Inget har publicerats',
  questions: 'Just nu finns det inga frågor publicerade',
  info: 'Just nu finns det ingen information publicerad',
};

export class RenderLiveFeed extends Component {
  static propTypes = {
    round: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: 'all',
    };
  }

  render() {
    const { round } = this.props;

    return (
      <Box bg="white" px={{ _: 3, md: '3,5' }} py={{ _: 3, md: '3,5' }}>
        <LiveFeed
          slug={round.slug}
          render={({ liveFeed, liveFeedQuestions, liveFeedInfo }) => (
            <Fragment>
              <HeaderDiv>
                <StyledPageTitle>Live</StyledPageTitle>
                <Info>Sidan uppdateras automatiskt.</Info>
              </HeaderDiv>
              <QuestionForm round={round} />
              <LiveFilter
                selected={this.state.selectedFilter}
                onClick={filter => this.setState({ selectedFilter: filter })}
              />
              {(() => {
                switch (this.state.selectedFilter) {
                  case 'questions':
                    return liveFeedQuestions;
                  case 'info':
                    return liveFeedInfo;
                  default:
                    return liveFeed;
                }
              })().map(post => (
                <LiveItem key={post.id}>
                  <Timeline>
                    <Time
                      date={new Date(post.created)}
                      format="HH:mm"
                      icon={<StyledSchedule />}
                    />
                  </Timeline>
                  <PostWrapper>
                    {post.content_type === 'live' ? (
                      <StyledWysiwygText html={post.text} />
                    ) : (
                      <InterviewItem interview={post} live />
                    )}
                  </PostWrapper>
                </LiveItem>
              ))}
              {(this.state.selectedFilter === 'all' && liveFeed.length === 0) ||
              (this.state.selectedFilter === 'questions' &&
                liveFeedQuestions.length === 0) ||
              (this.state.selectedFilter === 'info' &&
                liveFeedInfo.length === 0) ? (
                <EmptyWrapper>
                  <img
                    src={emptyIcon}
                    alt={informTextMap[this.state.selectedFilter]}
                  />
                  <EmptyInformText>
                    {informTextMap[this.state.selectedFilter]}
                  </EmptyInformText>
                </EmptyWrapper>
              ) : null}
            </Fragment>
          )}
        />
      </Box>
    );
  }
}

export default access_control(RenderLiveFeed, 'live', 'Liveuppdateringar');
